import * as at from "./types";
import { types, apiActionCreator } from "@authzsvc/api-lib";

export const clearResources = () => async (dispatch) => {
  await dispatch({ type: at.CLEAR_RESOURCES });
};

export const clearMyGroups = () => async (dispatch) => {
  await dispatch({ type: at.CLEAR_MY_GROUPS });
};

export const getMyRequests = () => (dispatch) => {
  dispatch(
    apiActionCreator(types.GET_REQUESTS, {
      queryFilter: {},
    }),
  );
};

export const getRequestsToApprove = () => async (dispatch) => {
  return await dispatch(
    apiActionCreator(types.GET_REQUESTS_TO_APPROVE, {
      queryFilter: {},
    }),
  );
};

export const cancelRequest = (id) => async (dispatch) => {
  return await dispatch(apiActionCreator(types.CANCEL_REQUEST, { id: id }));
};

export const denyRequest = (id, reason) => async (dispatch) => {
  return await dispatch(
    apiActionCreator(types.DENY_REQUEST, {
      id: id,
      reason: reason,
    }),
  );
};

export const approveRequest = (id, reason) => async (dispatch) => {
  return await dispatch(
    apiActionCreator(types.APPROVE_REQUEST, {
      id: id,
      reason: reason,
    }),
  );
};

export const resolveIdentity = (identityid) => async (dispatch) => {
  return await dispatch(
    apiActionCreator(types.RESOLVE_IDENTITY, { identityid: identityid }),
  );
};

export const setBreadcrumbs = (nav) => (dispatch) => {
  dispatch({
    type: at.SET_BREADCRUMBS,
    payload: { nav: nav },
  });
};
